module.exports = __webpack_public_path__ + "static/img/7bg_5.0fcaf80.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_5.png
// module id = 751
// module chunks = 1